<template>
    <portal to="PortalGraphTypeList">
        <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray">
            <!-- ' \nCe graphique est disponible lorsqu\'une seule données est demandée.' -->
            <b-button v-b-tooltip.hover @click="changeTypeGraph('HorizontalBar')" :title="$t('HorizontalBarChart') +
                    (configs && ('Data' in configs) && configs.Data.length !== 1 ?
                    ' \n' + $tc('ChartAvailable', 1) : '')"
                      :pressed="configs?.WorkParameters?.ChartWorkParameters?.graphType === 'HorizontalBar'"
                      pill variant="outline-white"
                      :disabled="configs && ('Data' in configs) && configs.Data.length !== 1"
                      :class="[ 'p-1 graphMode border-0',
                      {'text-black' : getConfigWorkParameters(['ChartWorkParameters', 'graphType'], defaultGraphType) != 'HorizontalBar'}]"> 
                <b-iconstack>
                    <b-icon icon="text-right" rotate="180" shift-v="2" scale="0.75" shift-h="-1"></b-icon>
                    <b-icon icon="slash" rotate="45" shift-v="-4" scale="0.75" shift-h="-2"></b-icon>
                </b-iconstack>
            </b-button>
            <!-- ' \nCe graphique est disponible lorsque deux données sont demandées.' -->
            <b-button v-b-tooltip.hover @click="changeTypeGraph('Scatter2D')" :title="$t('Scatter2D') +
                    (configs && ('Data' in configs) && configs.Data.length !== 2 ?
                    ' \n' + $tc('ChartAvailable', 2, { number : 2 }) : '')"
                      :pressed="configs?.WorkParameters?.ChartWorkParameters?.graphType === 'Scatter2D'"
                      pill variant="outline-white"
                      :disabled="configs && ('Data' in configs) && configs.Data.length !== 2"
                      :class="[ 'p-1 graphMode border-0',
                      {'text-black' : getConfigWorkParameters(['ChartWorkParameters', 'graphType'], defaultGraphType) != 'Scatter2D'}]"> <!-- ' \nCe graphique est disponible lorsque deux données sont demandées.' -->
                <b-iconstack>
                    <b-icon icon="arrow90deg-right" scale="0.6" shift-v="-2" shift-h="2"></b-icon>
                    <b-icon icon="arrow90deg-left" scale="0.6" rotate="90" shift-v="4" shift-h="-4"></b-icon>
                    <b-icon icon="plus" scale="0.5" shift-v="-5" shift-h="2"></b-icon>
                    <b-icon icon="plus" scale="0.5" shift-v="6" shift-h="4"></b-icon>
                    <b-icon icon="plus" scale="0.5" shift-v="3" shift-h="1"></b-icon>
                    <b-icon icon="plus" scale="0.5" shift-v="3" shift-h="-7"></b-icon>
                </b-iconstack>
            </b-button>
            <!-- ' \nCe graphique est disponible lorsque trois données sont demandées.' -->
            <b-button v-b-tooltip.hover @click="changeTypeGraph('Scatter3D')" :title="$t('Scatter3D') +
                    (configs && ('Data' in configs) && configs.Data.length !== 3 ?
                    ' \n' + $tc('ChartAvailable', 2, { number : 3 }) : '')"
                      :pressed="configs?.WorkParameters?.ChartWorkParameters?.graphType === 'Scatter3D'"
                      pill variant="outline-white"
                      :disabled="configs && ('Data' in configs) && configs.Data.length !== 3"
                      :class="[ 'p-1 graphMode border-0',
                      {'text-black' : getConfigWorkParameters(['ChartWorkParameters', 'graphType'], defaultGraphType) != 'Scatter3D'}]">
                <b-iconstack>
                    <b-icon icon="arrow90deg-right" scale="0.6" shift-v="-2" shift-h="2"></b-icon>
                    <b-icon icon="arrow90deg-left" scale="0.6" rotate="90" shift-v="4" shift-h="-4"></b-icon>
                    <b-icon icon="dot" scale="1.5" shift-v="-5" shift-h="2"></b-icon>
                    <b-icon icon="dot" scale="1.5" shift-v="6" shift-h="4"></b-icon>
                    <b-icon icon="dot" scale="0.5" shift-v="3" shift-h="1"></b-icon>
                    <b-icon icon="dot" scale="0.75" shift-v="3" shift-h="-7"></b-icon>
                </b-iconstack>
            </b-button>
            <!-- 'Ce graphique est disponible lorsqu\'une seule donnée est demandée avec une répartition.' -->
            <b-button v-b-tooltip.hover @click="changeTypeGraph('Sunburst')" :title="$t('PieChart') +
                    (configs && ('Data' in configs) && configs.Data.length !== 1 ?
                    ' \n' + $t('PieChartAvailable') : '')"
                      :disabled="configs && ('Data' in configs) &&
                            !(configs.Data.length === 1)"
                      :pressed="configs?.WorkParameters?.ChartWorkParameters?.graphType === 'Sunburst'"
                      pill variant="outline-white"
                      :class="[ 'p-1 graphMode border-0',
                       {'text-black' : getConfigWorkParameters(['ChartWorkParameters', 'graphType'], defaultGraphType) != 'Sunburst'}]">
                <b-icon icon="pie-chart"></b-icon>
            </b-button>
        </b-button-group>


        <!--<b-row>
            <b-col cols="auto" class="p-0 px-1"
                   v-if="configs && ('Data' in configs) && configs.Data.length === 1">
                <b-button @click="changeTypeGraph('barTen')" variant="outline-secondary" size="sm"
                          :pressed="getConfigWorkParameters(['ChartWorkParameters', 'graphType'], 'bar') === 'barTen'">
                    <b-iconstack>
                        <b-icon icon="arrow-down" shift-h="-10"></b-icon>
                        <b-icon icon="bar-chart-line-fill" rotate="90" flip-v shift-h="2"></b-icon>
                    </b-iconstack>
                    <span>10</span>
                </b-button>
            </b-col>
            <b-col cols="auto" class="p-0 px-1"
                   v-if="configs && ('Data' in configs) && configs.Data.length === 1">
                <b-button @click="changeTypeGraph('bar')" variant="outline-secondary" size="sm"
                          :pressed="getConfigWorkParameters(['ChartWorkParameters', 'graphType'], 'bar') === 'bar'">
                    <b-iconstack>
                        <b-icon icon="arrow-down" shift-h="-10"></b-icon>
                        <b-icon icon="bar-chart-line-fill" rotate="90" flip-v shift-h="2"></b-icon>
                    </b-iconstack>
                </b-button>
            </b-col>
            <b-col cols="auto" class="p-0 px-1"
                   v-if="configs && ('Data' in configs) && configs.Data.length >= 2">
                <b-button @click="changeTypeGraph('bar')" variant="outline-secondary" size="sm"
                          :pressed="getConfigWorkParameters(['ChartWorkParameters', 'graphType'], 'bar') === 'scatter'">
                    <b-iconstack>
                        <b-icon icon="clouds-fill" shift-v="4" shift-h="3"></b-icon>
                        <b-icon icon="slash-lg" rotate="45" shift-v="-7" shift-h="-2"></b-icon>
                        <b-icon icon="slash-lg" rotate="-45" shift-v="-1" shift-h="-7"></b-icon>
                    </b-iconstack>
                </b-button>
            </b-col>
        </b-row>-->
    </portal>
</template>

<script lang="ts">
import {PropSync, Vue} from "vue-property-decorator";
import Dictionary from "@/types/Dictionary";
import Component from "vue-class-component";
import locales from './locales/ChartWorkBenchmarking.json';

@Component({
    i18n: { messages : locales }
})
export default class ChartWorkBenchmarking extends Vue {
    /** Données synchronisées pour le composant appelant */
    @PropSync('Configs', {default: () => [{}]})
    public configs!: Dictionary<any>;

    /** Option du graphique Apache EChart */
    @PropSync('Result', {
        default: () => {
            option: {
            }
            ;
            graphTheme: "default-theme";
            menus: [];
        }
    })
    public results!: any;

    @PropSync('Messages', {default: () => []})
    public messages!: string[];

    private defaultGraphType: string = 'HorizontalBar';

    /**
     * Indique si le type de graphique dans la config est identique au nom du bouton.
     * @param workParameters
     * @param defaultValue
     * @private
     */
    private getConfigWorkParameters(workParameters: string[], defaultValue) {
        //console.debug("ChartWork.vue - getConfigWorkParameters() - paramètre d'entrée", workParameters, defaultValue);
        if (this.configs && ('WorkParameters' in this.configs)) {
            let config = this.configs.WorkParameters;
            for (let i = 0; i < workParameters.length; i++) {
                //console.debug('ChartWork.vue - getConfigWorkParameters() - workParameters[i] : ', workParameters[i], config);
                if (config && (workParameters[i]) in config) {
                    config = config[workParameters[i]];
                } else {
                    //console.debug('ChartWork.vue - changeConfig() - break');
                    config = defaultValue;
                    break;
                }
            }

            return config;
        } else {
            //console.debug('ChartWork.vue - getConfigWorkParameters() - defaultValue :', defaultValue);
            return defaultValue;
        }
    }

    /** Changement du type de graphique via boutons */
    private changeTypeGraph(value: string) {
        let oldValue = this.getConfigWorkParameters(['ChartWorkParameters', 'graphType'], this.defaultGraphType);
        console.debug('ChartWork.vue - changeTypeGraph() - oldValue, newValue :', oldValue, value);

        this.changeConfigWorkParameters(['ChartWorkParameters', 'graphType'], value, this.defaultGraphType);

        if (oldValue != value) {
            this.messages.splice(0, this.messages.length);
            this.messages.push(this.$t('GraphTypeChangeRefresh').toString()); // 'Le changement de typologie de graphique nécessite une actualisation du panneau de données.'
            console.debug('ChartWork.vue - changeTypeGraph() - configs, messages :', this.configs, this.messages);

            let type: string = 'bar';
            type = value == 'Sunburst' ? 'sunburst' : 'bar';

            if (this.configs && ('WorkParameters' in this.configs) && this.configs.WorkParameters
                && ('ChartWorkParameters' in this.configs.WorkParameters) && this.configs.WorkParameters.ChartWorkParameters
                && ('yAxis' in this.configs.WorkParameters.ChartWorkParameters) && this.configs.WorkParameters.ChartWorkParameters.yAxis
                && Array.isArray(this.configs.WorkParameters.ChartWorkParameters.yAxis)
                && ('length' in this.configs.WorkParameters.ChartWorkParameters.yAxis)) {
                for (let a = 0; a < this.configs.WorkParameters.ChartWorkParameters.yAxis.length; a++) {
                    let yAxis = this.configs.WorkParameters.ChartWorkParameters.yAxis[a];
                    if (yAxis && ('Datas' in yAxis) && Array.isArray(yAxis.Datas)) {
                        for (let b = 0; b < yAxis.Datas.length; b++) {
                            let result = this.changeConfigWorkParameters(['ChartWorkParameters', 'yAxis', a.toString(), 'Datas', b.toString(), 'Type'], type, 'bar');
                            this.changeConfigWorkParameters(['ChartWorkParameters', 'yAxis', a.toString(), 'subType'], undefined, undefined);
                        }
                    }
                    // @todo : mettre le bouton Actualiser en couleur. L'utilisateur doit actualiser le graphique pour changer de type.
                }
            }
            if (this.configs && ('WorkParameters' in this.configs) && this.configs.WorkParameters
                && ('ChartWorkParameters' in this.configs.WorkParameters) && this.configs.WorkParameters.ChartWorkParameters
                && ('xAxis' in this.configs.WorkParameters.ChartWorkParameters) && this.configs.WorkParameters.ChartWorkParameters.xAxis
                && Array.isArray(this.configs.WorkParameters.ChartWorkParameters.xAxis)
                && ('length' in this.configs.WorkParameters.ChartWorkParameters.xAxis)) {
                for (let a = 0; a < this.configs.WorkParameters.ChartWorkParameters.xAxis.length; a++) {
                    let xAxis = this.configs.WorkParameters.ChartWorkParameters.xAxis[a];
                    if (xAxis && ('Datas' in xAxis) && Array.isArray(xAxis.Datas)) {
                        for (let b = 0; b < xAxis.Datas.length; b++) {
                            let result = this.changeConfigWorkParameters(['ChartWorkParameters', 'xAxis', a.toString(), 'Datas', b.toString(), 'Type'], type, 'bar');
                            this.changeConfigWorkParameters(['ChartWorkParameters', 'xAxis', a.toString(), 'subType'], undefined, undefined);
                        }
                    }
                    // @todo : mettre le bouton Actualiser en couleur. L'utilisateur doit actualiser le graphique pour changer de type.
                }
            }
            console.debug('ChartWork.vue - changeTypeGraph() - configs, messages :', this.configs, this.messages);
        }
    }

    /** Change la valeur de la Config au niveau des Works */
    private changeConfigWorkParameters(workParameters: string[], value, defaultValue, funct: string = undefined): any {
        console.debug("ChartWork.vue - changeConfigWorkParameters() - paramètre d'entrée", workParameters, value, defaultValue);
        if (this.configs && ('WorkParameters' in this.configs)) {
            let config = this.configs.WorkParameters;
            for (let i = 0; i < workParameters.length; i++) {
                console.debug('ChartWork.vue - changeConfigWorkParameters() - workParameters[i] : ', workParameters[i], config);
                if ((workParameters[i] in config)) {
                    if (i == workParameters.length - 1) {
                        if (value != config[workParameters[i]]) {
                            config[workParameters[i]] = value;
                            console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value :', this.configs, value);
                        }
                    } else {
                        if (config != config[workParameters[i]]) {
                            config = config[workParameters[i]];
                            console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value :', this.configs, value);
                        }
                    }
                } else if (i == workParameters.length - 1) {
                    if (value != config[workParameters[i]]) {
                        config[workParameters[i]] = value;
                        console.debug('ChartWork.vue - changeConfigWorkParameters() - this.configs, value :', this.configs, value);
                    }
                } else {
                    console.debug('ChartWork.vue - changeConfigWorkParameters() - break');
                    break;
                }
            }
            return value;
        } else {
            console.debug('ChartWork.vue - changeConfigWorkParameters() - defaultValue :', defaultValue);
            return defaultValue;
        }
    }
}
</script>

<style scoped>

/** Style appliqué pour les boutons de selection du mode de période (Simple <=> Avancée) */
:deep(.btn.active.graphMode) {
    background-color: var(--white) !important;
    color: var(--secondary) !important;
}
</style>